// ── CONFIG ────────────────────────────────────────────
const CLOUDINARY_CLOUD  = 'oriwgyab';
const CLOUDINARY_PRESET = 'berniture_rooms';
const BACKEND_URL = 'https://staging.api.berniture.com/room-requests';
// ──────────────────────────────────────────────────────

// ── TRANSLATIONS ──
const T = {
  ar: {
    stepLabel:    (n) => `الخطوة ${n} من 3`,
    s1Title:      'صمّم أوضتك مع Berniture',
    s2Title:      'إيه أبعاد الأوضة؟',
    s3Title:      'ارفع صور الأوضة أو الإنسبيريشن',
    living_room:  'أوضة معيشة',
    bedroom:      'أوضة نوم',
    dining_room:  'أوضة سفرة',
    office:       'مكتب',
    tv_units:     'وحدات تلفزيون',
    other:        'أخرى',
    lblName:      'الاسم الكامل',
    namePH:       'محمد أحمد',
    lblPhone:     'رقم التليفون (للتواصل)',
    lblWidth:     'العرض',
    lblLength:    'الطول',
    lblHeight:    'الارتفاع',
    areaLabel:    (a) => `المساحة: ${a} م²`,
    dimUnit:      'سم',
    uploadTitle:  'ارفع صور الأوضة أو من Pinterest',
    uploadSub:    'حتى 10 صور — JPG, PNG, WEBP',
    lblNotes:     'تفاصيل إضافية (اختياري)',
    notesPH:      'مثال: بحب الألوان الدافية، أو عندي قطعة موجودة عايز أحتفظ بيها...',
    btnNext:      'التالي ←',
    btnBack:      '→ رجوع',
    btnSubmit:    'أرسل طلبك 🛋️',
    loadingImg:   'بنرفع الصور...',
    loadingSend:  'بنبعت طلبك...',
    errDimensions:'أدخل أبعاد الأوضة (العرض والطول مطلوبين)',
    errRoomType:  'اختر نوع الأوضة',
    errName:      'أدخل اسمك',
    errPhone:     'أدخل رقم التليفون',
    successTitle: 'وصل طلبك! ✨',
    successSub:   'سيتم التواصل معك من خلال فريقنا في أقرب وقت\nلنبدأ نصمم أوضتك بأيدينا 🛋️',
  },
  en: {
    stepLabel:    (n) => `Step ${n} of 3`,
    s1Title:      'Design Your Room with Berniture',
    s2Title:      'What are your room dimensions?',
    s3Title:      'Upload room photos or inspiration',
    living_room:  'Living Room',
    bedroom:      'Bedroom',
    dining_room:  'Dining Room',
    office:       'Office',
    tv_units:     'TV Units',
    other:        'Other',
    lblName:      'Full Name',
    namePH:       'Mohamed Ahmed',
    lblPhone:     'Phone Number',
    lblWidth:     'Width',
    lblLength:    'Length',
    lblHeight:    'Height',
    areaLabel:    (a) => `Area: ${a} m²`,
    dimUnit:      'cm',
    uploadTitle:  'Upload room photos or Pinterest inspiration',
    uploadSub:    'Up to 10 images — JPG, PNG, WEBP',
    lblNotes:     'Additional details (optional)',
    notesPH:      'e.g. I prefer warm tones, or I have an existing piece I want to keep...',
    btnNext:      'Next →',
    btnBack:      '← Back',
    btnSubmit:    'Submit Request 🛋️',
    loadingImg:   'Uploading images...',
    loadingSend:  'Sending your request...',
    errDimensions:'Please enter room dimensions (width and length are required)',
    errRoomType:  'Please select a room type',
    errName:      'Please enter your name',
    errPhone:     'Please enter your phone number',
    successTitle: 'Request Received! ✨',
    successSub:   'Our team will be in touch with you shortly\nto start designing your room 🛋️',
  }
};

const SUPPORTED = ['ar', 'en'];
const detectedLang = (SHOPIFY_LOCALE || 'ar').split('-')[0].toLowerCase();
let lang = SUPPORTED.includes(detectedLang) ? detectedLang : 'ar';
let selectedRoomType = '';
let uploadedUrls = [];
let pendingFiles = [];
let currentStep = 1;

// ── LANG ──
function setLang(l) {
  lang = l;
  document.documentElement.lang = l;
  document.documentElement.dir  = l === 'ar' ? 'rtl' : 'ltr';
  applyTranslations();
}

function applyTranslations() {
  const t = T[lang];
  document.getElementById('stepLabel').textContent = t.stepLabel(currentStep);
  document.getElementById('s1Title').textContent   = t.s1Title;
  document.getElementById('s2Title').textContent   = t.s2Title;
  document.getElementById('s3Title').textContent   = t.s3Title;

  // room type labels
  document.querySelectorAll('.room-option .label[data-key]').forEach(el => {
    el.textContent = t[el.dataset.key] || el.dataset.key;
  });

  document.getElementById('lblName').textContent   = t.lblName;
  document.getElementById('inputName').placeholder = t.namePH;
  document.getElementById('lblPhone').textContent  = t.lblPhone;
  document.getElementById('lblWidth').textContent  = t.lblWidth;
  document.getElementById('lblLength').textContent = t.lblLength;
  document.getElementById('lblHeight').textContent = t.lblHeight;
  document.getElementById('unitLabel').textContent  = t.dimUnit;
  document.getElementById('unitLabel2').textContent = t.dimUnit;
  document.getElementById('unitLabel3').textContent = t.dimUnit;

  document.getElementById('uploadTitle').textContent = t.uploadTitle;
  document.getElementById('uploadSub').textContent   = t.uploadSub;
  document.getElementById('lblNotes').textContent    = t.lblNotes;
  document.getElementById('inputNotes').placeholder  = t.notesPH;

  document.getElementById('btnNext1').textContent  = t.btnNext;
  document.getElementById('btnNext2').textContent  = t.btnNext;
  document.getElementById('btnBack2').textContent  = t.btnBack;
  document.getElementById('submitBtn').textContent = t.btnSubmit;
  document.getElementById('btnBack3').textContent  = t.btnBack;

  document.getElementById('errDimensions').textContent = t.errDimensions;
  document.getElementById('errRoomType').textContent = t.errRoomType;
  document.getElementById('errName').textContent     = t.errName;
  document.getElementById('errPhone').textContent    = t.errPhone;

  document.getElementById('successTitle').textContent = t.successTitle;
  document.getElementById('successSub').innerHTML = t.successSub.replace('\n', '<br/>');

  updateRoom(); // refresh area label
}

// ── ROOM TYPE ──
document.querySelectorAll('.room-option').forEach(el => {
  el.addEventListener('click', () => {
    document.querySelectorAll('.room-option').forEach(o => o.classList.remove('selected'));
    el.classList.add('selected');
    selectedRoomType = el.dataset.value;
    document.getElementById('errRoomType').classList.remove('show');
  });
});

// ── PROGRESS ──
function goStep(n) {
  document.getElementById(`step${currentStep}`).classList.remove('active');
  currentStep = n;
  document.getElementById(`step${currentStep}`).classList.add('active');
  document.getElementById('stepLabel').textContent = T[lang].stepLabel(currentStep);
  for (let i = 1; i <= 3; i++) {
    document.getElementById(`prog${i}`).style.width = i <= currentStep ? '100%' : '0%';
  }
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

function goStep2() {
  let ok = true;
  if (!selectedRoomType) { document.getElementById('errRoomType').classList.add('show'); ok = false; }
  const name = document.getElementById('inputName').value.trim();
  if (name.length < 2) {
    document.getElementById('errName').classList.add('show');
    document.getElementById('inputName').classList.add('error'); ok = false;
  } else {
    document.getElementById('errName').classList.remove('show');
    document.getElementById('inputName').classList.remove('error');
  }
  const phone = document.getElementById('inputPhone').value.trim();
  if (phone.length < 7) {
    document.getElementById('errPhone').classList.add('show');
    document.getElementById('inputPhone').classList.add('error'); ok = false;
  } else {
    document.getElementById('errPhone').classList.remove('show');
    document.getElementById('inputPhone').classList.remove('error');
  }
  if (ok) goStep(2);
}
function goStep3() {
  const w = parseFloat(document.getElementById('inputWidth').value);
  const l = parseFloat(document.getElementById('inputLength').value);
  const h = parseFloat(document.getElementById('inputHeight').value);
  const errDim = document.getElementById('errDimensions');
  const lang_err = (SHOPIFY_LOCALE === 'ar')
    ? 'يرجى إدخال أبعاد صحيحة (العرض والطول بين 50 و 20000 سم، الارتفاع بين 100 و 500 سم)'
    : 'Please enter valid dimensions (width & length 50–20000 cm, height 100–500 cm)';
  const wOk = w >= 50 && w <= 20000;
  const lOk = l >= 50 && l <= 20000;
  const hOk = !h || (h >= 100 && h <= 500);
  if (!wOk || !lOk || !hOk) {
    errDim.textContent = lang_err;
    errDim.classList.add('show');
    document.getElementById('inputWidth').classList.toggle('error', !wOk);
    document.getElementById('inputLength').classList.toggle('error', !lOk);
    document.getElementById('inputHeight').classList.toggle('error', !hOk);
    return;
  }
  errDim.classList.remove('show');
  document.getElementById('inputWidth').classList.remove('error');
  document.getElementById('inputLength').classList.remove('error');
  document.getElementById('inputHeight').classList.remove('error');
  goStep(3);
}

// ── ROOM VISUALIZER ──
function updateRoom() {
  const w = parseFloat(document.getElementById('inputWidth').value)  || 0;
  const l = parseFloat(document.getElementById('inputLength').value) || 0;
  if (!w || !l) {
    document.getElementById('areaBadge').textContent = T[lang].areaLabel('—');
    document.getElementById('dimTop').textContent  = '— ' + T[lang].dimUnit;
    document.getElementById('dimSide').textContent = '— ' + T[lang].dimUnit;
    document.getElementById('roomRect').style.width  = '120px';
    document.getElementById('roomRect').style.height = '80px';
    return;
  }
  const MAX_W = 200, MAX_H = 170;
  const ratio = w / l;
  let rW, rH;
  if (ratio > MAX_W / MAX_H) { rW = MAX_W; rH = MAX_W / ratio; }
  else                        { rH = MAX_H; rW = MAX_H * ratio; }
  rW = Math.max(60, rW); rH = Math.max(60, rH);

  const rect = document.getElementById('roomRect');
  rect.style.width  = rW + 'px';
  rect.style.height = rH + 'px';

  const t = T[lang];
  document.getElementById('dimTop').textContent  = `${Math.round(w)} ${t.dimUnit}`;
  document.getElementById('dimSide').textContent = `${Math.round(l)} ${t.dimUnit}`;

  const area = (w / 100) * (l / 100);
  document.getElementById('areaBadge').textContent = t.areaLabel(area.toFixed(1));
}

// ── FILE UPLOAD ──
const uploadZone = document.getElementById('uploadZone');
uploadZone.addEventListener('dragover',  e => { e.preventDefault(); uploadZone.classList.add('drag-over'); });
uploadZone.addEventListener('dragleave', ()  => uploadZone.classList.remove('drag-over'));
uploadZone.addEventListener('drop', e => {
  e.preventDefault(); uploadZone.classList.remove('drag-over');
  handleFiles(e.dataTransfer.files);
});

function handleFiles(files) {
  const remaining = 10 - (uploadedUrls.length + pendingFiles.length);
  Array.from(files).slice(0, remaining).forEach((file, i) => {
    if (!file.type.startsWith('image/')) return;
    const idx = pendingFiles.length;
    pendingFiles.push(file);
    const reader = new FileReader();
    reader.onload = e => {
      const previews = document.getElementById('previews');
      const item = document.createElement('div');
      item.className = 'preview-item'; item.id = `preview_${idx}`;
      item.innerHTML = `<img src="${e.target.result}" /><div class="uploading-overlay"><div class="spinner"></div></div>`;
      previews.appendChild(item);
    };
    reader.readAsDataURL(file);
  });
}

// ── IMAGE COMPRESSION ──
async function compressImage(file, maxPx = 1920, quality = 0.82, maxBytes = 800 * 1024) {
  return new Promise((resolve) => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      URL.revokeObjectURL(url);
      let { width, height } = img;
      // Scale down if larger than maxPx
      if (width > maxPx || height > maxPx) {
        if (width > height) { height = Math.round(height * maxPx / width); width = maxPx; }
        else                { width  = Math.round(width  * maxPx / height); height = maxPx; }
      }
      const canvas = document.createElement('canvas');
      canvas.width = width; canvas.height = height;
      canvas.getContext('2d').drawImage(img, 0, 0, width, height);
      // Try quality 0.82, if still too big drop to 0.65 then 0.50
      const tryQuality = (q) => {
        canvas.toBlob((blob) => {
          if (blob.size > maxBytes && q > 0.50) { tryQuality(q - 0.17); return; }
          resolve(new File([blob], file.name.replace(/\.[^.]+$/, '.jpg'), { type: 'image/jpeg' }));
        }, 'image/jpeg', q);
      };
      tryQuality(quality);
    };
    img.onerror = () => { URL.revokeObjectURL(url); resolve(file); }; // fallback: upload original
    img.src = url;
  });
}

async function uploadToCloudinary(file) {
  const compressed = await compressImage(file);
  const fd = new FormData();
  fd.append('file', compressed);
  fd.append('upload_preset', CLOUDINARY_PRESET);
  const res  = await fetch(`https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD}/image/upload`, { method: 'POST', body: fd });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error?.message || 'Upload failed');
  return data.secure_url;
}

// ── SUBMIT ──
async function submitForm() {
  const submitBtn  = document.getElementById('submitBtn');
  const errGeneral = document.getElementById('errGeneral');
  const loading    = document.getElementById('loadingOverlay');
  const loadingTxt = document.getElementById('loadingText');
  errGeneral.classList.remove('show');
  submitBtn.disabled = true;

  try {
    if (pendingFiles.length > 0) {
      loading.classList.add('show');
      loadingTxt.textContent = T[lang].loadingImg;
      const results = await Promise.allSettled(pendingFiles.map(uploadToCloudinary));
      results.forEach((r, i) => {
        const el = document.getElementById(`preview_${i}`);
        if (r.status === 'fulfilled') { uploadedUrls.push(r.value); el?.querySelector('.uploading-overlay')?.remove(); }
        else { el?.remove(); }
      });
      pendingFiles = [];
    }

    loadingTxt.textContent = T[lang].loadingSend;
    loading.classList.add('show');

    const res = await fetch(BACKEND_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name:       document.getElementById('inputName').value.trim(),
        phone:      document.getElementById('inputPhone').value.trim(),
        room_type:  selectedRoomType,
        width_m:    (parseFloat(document.getElementById('inputWidth').value)  || 0) / 100,
        length_m:   (parseFloat(document.getElementById('inputLength').value) || 0) / 100,
        height_m:   (parseFloat(document.getElementById('inputHeight').value) || 0) / 100,
        notes:      document.getElementById('inputNotes').value.trim() || undefined,
        image_urls: uploadedUrls,
      }),
    });

    if (!res.ok) { const err = await res.json(); throw new Error(err.error || 'Error'); }

    loading.classList.remove('show');
    document.getElementById('progressWrap').style.display = 'none';
    document.getElementById('stepLabel').style.display    = 'none';
    document.getElementById(`step${currentStep}`).classList.remove('active');
    document.getElementById('successScreen').classList.add('show');
    // Lottie success animation
    if (typeof lottie !== 'undefined') {
      lottie.loadAnimation({
        container: document.getElementById('lottieSuccess'),
        renderer:  'svg',
        loop:      false,
        autoplay:  true,
        path:      'https://assets10.lottiefiles.com/packages/lf20_jbrw3hcz.json'
      });
    }

  } catch (err) {
    loading.classList.remove('show');
    submitBtn.disabled = false;
    errGeneral.textContent = err.message;
    errGeneral.classList.add('show');
  }
}

// ── INIT ──
setLang(lang);
updateRoom();
// Set initial progress state (step 1 active on load)
for (let _i = 1; _i <= 3; _i++) {
  document.getElementById(`prog${_i}`).style.width = _i <= currentStep ? '100%' : '0%';
}
// Fix header overlap on page load
document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('header, .header-wrapper, #shopify-section-header');
  const progressWrap = document.getElementById('progressWrap');
  if (header && progressWrap) {
    const headerHeight = header.offsetHeight;
    progressWrap.style.marginTop = headerHeight + 'px';
  }
});
